import { render, staticRenderFns } from "./postback.vue?vue&type=template&id=2d32b67a&"
import script from "./postback.vue?vue&type=script&lang=js&"
export * from "./postback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports